const indexedPaths = {
  "fastqrgenerator.com": ["/", "/contact-us"],
  "qrcreator.com": ["/", "/contact-us"],
  "app.qrcreator.com": [],
  "onlineqrcode.com": [],
  "app.onlineqrcode.com": [],
  "qrnow.com": [],
  "app.qrnow.com": [],
};

module.exports = {
  indexedPaths,
};
